import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useFinicityLinkContext } from './FinicityLinkContext';

import { FINICITY_CONNECT_ELEMENT_ID } from '.';

const styles = theme => ({
  root: {},
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    backgroundColor: theme.palette.common.white,
    width: '100vw',
    height: '100vh',
    zIndex: theme.zIndex.modal,
    overflowY: 'auto',
    maxWidth: '100%',
  },
  containerHidden: {
    display: 'none',
  },
});

const FinicityLinkContent = ({
  className,
  classes,
  resource,
  renderButtonComponentChildren,
  ButtonComponent,
  ButtonComponentProps,
}) => {
  const {
    handleClick,
    isInitialized,
    showConnectView,
  } = useFinicityLinkContext();

  return (
    <div className={classNames(classes.root, className)}>
      <ButtonComponent
        {...ButtonComponentProps}
        className={classes.buttonComponent}
        disabled={!isInitialized}
        onClick={handleClick}
      >
        {renderButtonComponentChildren(resource)}
      </ButtonComponent>
      <div
        id={FINICITY_CONNECT_ELEMENT_ID}
        className={classNames(classes.container, {
          [classes.containerHidden]: !showConnectView,
        })}
      />
    </div>
  );
};

FinicityLinkContent.defaultProps = {
  className: '',
};

FinicityLinkContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  renderButtonComponentChildren: PropTypes.func.isRequired,
  ButtonComponent: PropTypes.object.isRequired,
  ButtonComponentProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(FinicityLinkContent);
